/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityVisibilityResponse {
    getFixupPrototypeFunction() { return SecurityVisibilityResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityVisibilityResponse>): SecurityVisibilityResponse {
        let obj = Object.assign(new SecurityVisibilityResponse(), model);
        SecurityVisibilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityVisibilityResponse>): SecurityVisibilityResponse {
        if (!model) return null;
        return SecurityVisibilityResponse.newInstance(<SecurityVisibilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityVisibilityResponse) {
        if (!obj) return;

        models.SecurityVisibilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityVisibilityResponse): boolean {
        Object.setPrototypeOf(obj, SecurityVisibilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Visibility of the findings by cloud_accounts
     */
    cloud_accounts: any;

    /**
     * Visibility of the findings by findings_type
     */
    findings_type: any;

    /**
     * Visibility of the findings by resource_types
     */
    resource_types: any;

    /**
     * Visibility of the findings by intent
     */
    intent: any;

    /**
     * Visibility of the findings count_summary
     */
    count_summary: any;

}
